import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Naming It",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I stop thinking “something is wrong with me” and call it by its name: a sense of failure."
    ],
      [
      "Daily intention: Today I stop thinking “something is wrong with me” and call it by its name: a sense of failure."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "In my heart: “This is a feeling. Not a verdict.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "In my heart: “This is a feeling. Not a verdict.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Where in my life does the sense of failure keep returning?\n[Write here]",
      "2. What story do I tell myself about it?\n[Write here]",
      "3. How does my body feel when I think “I failed”?\n[Write here]"
    ],
      [
      "1. Where in my life does the sense of failure keep returning?\n[Write here]",
      "2. What story do I tell myself about it?\n[Write here]",
      "3. How does my body feel when I think “I failed”?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Feeling failure is not being a failure."
    ],
      [
      "Closing",
      "Feeling failure is not being a failure."
    ]
    ),
    action: localizedGenderNode(
      "Once today: one breath + “This is a feeling, not an identity.”",
      "Once today: one breath + “This is a feeling, not an identity.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Facts vs. Conclusions",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate what happened from what I say it means about me."
    ],
      [
      "Daily intention: Today I separate what happened from what I say it means about me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What is the raw fact? (no interpretation)\n[Write here]",
      "2. What harsh conclusion jumped in immediately?\n[Write here]",
      "3. What gentler interpretation is also possible?\n[Write here]"
    ],
      [
      "1. What is the raw fact? (no interpretation)\n[Write here]",
      "2. What harsh conclusion jumped in immediately?\n[Write here]",
      "3. What gentler interpretation is also possible?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A conclusion is not a fact."
    ],
      [
      "Closing",
      "A conclusion is not a fact."
    ]
    ),
    action: localizedGenderNode(
      "“Fact ≠ identity.”",
      "“Fact ≠ identity.”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The Measuring Voice",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I recognize the voice that measures success and failure."
    ],
      [
      "Daily intention: Today I recognize the voice that measures success and failure."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. How does this voice speak to me?\n[Write here]",
      "2. Where did it learn to measure like this?\n[Write here]",
      "3. What different tone would I want?\n[Write here]"
    ],
      [
      "1. How does this voice speak to me?\n[Write here]",
      "2. Where did it learn to measure like this?\n[Write here]",
      "3. What different tone would I want?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t have to believe a voice that shrinks me."
    ],
      [
      "Closing",
      "I don’t have to believe a voice that shrinks me."
    ]
    ),
    action: localizedGenderNode(
      "When measurement appears — “I heard you.”",
      "When measurement appears — “I heard you.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Failure as an Event, Not an Identity",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate what happened from who I am."
    ],
      [
      "Daily intention: Today I separate what happened from who I am."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Which “failure” have I been carrying for years?\n[Write here]",
      "2. What does it say about my attempt — not my worth?\n[Write here]",
      "3. What did I actually learn from it?\n[Write here]"
    ],
      [
      "1. Which “failure” have I been carrying for years?\n[Write here]",
      "2. What does it say about my attempt — not my worth?\n[Write here]",
      "3. What did I actually learn from it?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Events happen. I remain."
    ],
      [
      "Closing",
      "Events happen. I remain."
    ]
    ),
    action: localizedGenderNode(
      "Sentence: “It happened — and I’m still here.”",
      "Sentence: “It happened — and I’m still here.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Comparison That Feeds Failure",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I see how comparison strengthens the sense of failure."
    ],
      [
      "Daily intention: Today I see how comparison strengthens the sense of failure."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Who do I compare myself to?\n[Write here]",
      "2. What don’t I see in their story?\n[Write here]",
      "3. What does exist in my life — even quietly?\n[Write here]"
    ],
      [
      "1. Who do I compare myself to?\n[Write here]",
      "2. What don’t I see in their story?\n[Write here]",
      "3. What does exist in my life — even quietly?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Comparison erases context."
    ],
      [
      "Closing",
      "Comparison erases context."
    ]
    ),
    action: localizedGenderNode(
      "One comparison stop today.",
      "One comparison stop today."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "The Body and Failure",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I listen to my body, not only my thoughts."
    ],
      [
      "Daily intention: Today I listen to my body, not only my thoughts."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Slow breath."
    ],
      [
      "Slow breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Where does failure sit in my body?\n[Write here]",
      "2. What does my body need right now?\n[Write here]",
      "3. What small relief is possible?\n[Write here]"
    ],
      [
      "1. Where does failure sit in my body?\n[Write here]",
      "2. What does my body need right now?\n[Write here]",
      "3. What small relief is possible?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "The body asks for listening, not criticism."
    ],
      [
      "Closing",
      "The body asks for listening, not criticism."
    ]
    ),
    action: localizedGenderNode(
      "Hand on chest/belly + breath.",
      "Hand on chest/belly + breath."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Small Successes I Didn’t Count",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I notice successes that never got a headline."
    ],
      [
      "Daily intention: Today I notice successes that never got a headline."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Three things I did despite the difficulty:\n[Write here]",
      "2. Why do I tend to cancel them?\n[Write here]",
      "3. How does it feel to acknowledge them?\n[Write here]"
    ],
      [
      "1. Three things I did despite the difficulty:\n[Write here]",
      "2. Why do I tend to cancel them?\n[Write here]",
      "3. How does it feel to acknowledge them?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Progress doesn’t always make noise."
    ],
      [
      "Closing",
      "Progress doesn’t always make noise."
    ]
    ),
    action: localizedGenderNode(
      "Write one success in my journal.",
      "Write one success in my journal."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Carrying failure without escaping",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I allow the feeling to exist for one minute."
    ],
      [
      "Daily intention: Today I allow the feeling to exist for one minute."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What trigger brings up failure?\n[Write here]",
      "2. One-minute practice: I stay — without fixing.\nWhat happened?\n[Write here]"
    ],
      [
      "1. What trigger brings up failure?\n[Write here]",
      "2. One-minute practice: I stay — without fixing.\nWhat happened?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A wave rises and falls."
    ],
      [
      "Closing",
      "A wave rises and falls."
    ]
    ),
    action: localizedGenderNode(
      "One minute only.",
      "One minute only."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Responsibility Without Self-Punishment",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I take responsibility without attacking myself."
    ],
      [
      "Daily intention: Today I take responsibility without attacking myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What is truly my responsibility?\n[Write here]",
      "2. What is not?\n[Write here]",
      "3. What does responsibility with compassion look like?\n[Write here]"
    ],
      [
      "1. What is truly my responsibility?\n[Write here]",
      "2. What is not?\n[Write here]",
      "3. What does responsibility with compassion look like?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Responsibility builds — it doesn’t destroy."
    ],
      [
      "Closing",
      "Responsibility builds — it doesn’t destroy."
    ]
    ),
    action: localizedGenderNode(
      "One gentle sentence to myself.",
      "One gentle sentence to myself."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Failure and Fear",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I identify the fear beneath failure."
    ],
      [
      "Daily intention: Today I identify the fear beneath failure."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What am I afraid it says about me?\n[Write here]",
      "2. What is the real threat?\n[Write here]",
      "3. What calming truth exists?\n[Write here]"
    ],
      [
      "1. What am I afraid it says about me?\n[Write here]",
      "2. What is the real threat?\n[Write here]",
      "3. What calming truth exists?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Fear speaks loudly."
    ],
      [
      "Closing",
      "Fear speaks loudly."
    ]
    ),
    action: localizedGenderNode(
      "Breath + calming truth.",
      "Breath + calming truth."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Self-Worth Not Tied to Outcome",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate outcome from worth."
    ],
      [
      "Daily intention: Today I separate outcome from worth."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Where do I tie my worth to results?\n[Write here]",
      "2. Which quality in me exists regardless of success?\n[Write here]",
      "3. How does it feel to separate them?\n[Write here]"
    ],
      [
      "1. Where do I tie my worth to results?\n[Write here]",
      "2. Which quality in me exists regardless of success?\n[Write here]",
      "3. How does it feel to separate them?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I am more than an outcome."
    ],
      [
      "Closing",
      "I am more than an outcome."
    ]
    ),
    action: localizedGenderNode(
      "Write one quality about myself.",
      "Write one quality about myself."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Changing Inner Language",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I replace one word."
    ],
      [
      "Daily intention: Today I replace one word."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Which violent word do I say to myself?\n[Write here]",
      "2. How does it sound in human language?\n[Write here]",
      "3. Which new word do I choose?\n[Write here]"
    ],
      [
      "1. Which violent word do I say to myself?\n[Write here]",
      "2. How does it sound in human language?\n[Write here]",
      "3. Which new word do I choose?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Words create reality."
    ],
      [
      "Closing",
      "Words create reality."
    ]
    ),
    action: localizedGenderNode(
      "One replacement only.",
      "One replacement only."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Direction Instead of Proof",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I choose direction, not proof."
    ],
      [
      "Daily intention: Today I choose direction, not proof."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Which value matters to me now?\n[Write here]",
      "2. Which small action serves it?\n[Write here]",
      "3. What do I promise myself on hard days?\n[Write here]"
    ],
      [
      "1. Which value matters to me now?\n[Write here]",
      "2. Which small action serves it?\n[Write here]",
      "3. What do I promise myself on hard days?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Direction is enough."
    ],
      [
      "Closing",
      "Direction is enough."
    ]
    ),
    action: localizedGenderNode(
      "Plan one small step.",
      "Plan one small step."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I close a chapter without erasing myself."
    ],
      [
      "Daily intention: Today I close a chapter without erasing myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What changed in my relationship with failure?\n[Write here]",
      "2. What do I know now that I didn’t before?\n[Write here]",
      "3. A return sentence for hard days:\n[Write here]"
    ],
      [
      "1. What changed in my relationship with failure?\n[Write here]",
      "2. What do I know now that I didn’t before?\n[Write here]",
      "3. A return sentence for hard days:\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure",
      "I am not the sum of my failures.",
      "I am a person in process.",
      "And I stay with myself.",
      "That is strength."
    ],
      [
      "Final closure",
      "I am not the sum of my failures.",
      "I am a person in process.",
      "And I stay with myself.",
      "That is strength."
    ]
    ),
    action: localizedGenderNode(
      "One action that symbolizes continuation.",
      "One action that symbolizes continuation."
    ),
  },
].map(buildNormalizedDay);

export const chronicSenseOfFailureBlueprintEn = buildNormalizedPilotBlueprint({
  id: "chronic_sense_of_failure_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "chronic_sense_of_failure",
  category: "general",
  journeyName: {
    he: "תחושת כישלון כרונית",
    en: "Chronic Sense of Failure",
    es: "Sensación Crónica de Fracaso",
  },
  days,
});

export default chronicSenseOfFailureBlueprintEn;
